import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { exitIcon } from 'common/icons';
import {
  ModalContainer,
  ModalBox,
  ModalCloseButton,
  ModalContentContainer,
  ModalFooter,
  ModalOverlay,
  ModalTitle,
  ModalHeader,
  ModalSubheading,
} from './styled';
import Seperator from 'ui/components/Seperator';

export const Modal = ({
  children,
  header,
  footer,
  onClose,
  title,
  padding,
  minHeigh,
  minWidth,
  width,
  maxWidth,
  maxHeight,
  titleMargin,
  subHeading,
  seperatorWidth,
  ShowSeperator,
  titlePadding,
  testId,
  zIndex,
  ...props
}) => {
  useEffect(() => {
    document.body.style = 'overflow: hidden';
    document.addEventListener('keydown', function(e) {
      let keyCode = e.keyCode;
      if (keyCode === 27) {
        //keycode is an Integer, not a String
        onClose();
      }
    });
    return () => {
      document.body.style = 'overflow: unset';
      document.removeEventListener('keydown', function() {}, false);
    };
  }, [onClose]);

  const onModalClose = () => {
    onClose();
  };
  return (
    <ModalContainer zIndex={zIndex}>
      <ModalOverlay onClick={onModalClose} />
      <ModalBox
        data-testid={`insent-${testId}-container`}
        minHeigh={minHeigh}
        padding={padding}
        width={width}
        maxHeight={maxHeight}
        maxWidth={maxWidth}
      >
        <ModalHeader isHeader={header}>
          {header ? (
            header
          ) : (
            <ModalTitle data-testid={`insent-${testId}-title`} titlePadding={titlePadding}>
              {title}
            </ModalTitle>
          )}
          {subHeading && <ModalSubheading>{subHeading}</ModalSubheading>}
          {title && ShowSeperator && (
            <Seperator
              margin={titleMargin || '20px 0'}
              background={'#EDEFF1'}
              {...(seperatorWidth && { width: seperatorWidth })}
            />
          )}
          <ModalCloseButton data-testid={`insent-${testId}-close`} onClick={onModalClose}>
            {exitIcon()}
          </ModalCloseButton>
        </ModalHeader>

        <ModalContentContainer isHeader={header} isFooter={footer} maxHeight={maxHeight}>
          {children}
        </ModalContentContainer>
        {footer ? (
          <Seperator
            margin={'12px 0 0'}
            background={'#EDEFF1'}
            {...(seperatorWidth && { width: seperatorWidth })}
          />
        ) : null}
        {footer && <ModalFooter isHeader={header}>{footer()}</ModalFooter>}
      </ModalBox>
    </ModalContainer>
  );
};

Modal.propTypes = {
  onClose: PropTypes.func.isRequired,
  header: PropTypes.element,
  footer: PropTypes.element,
  title: PropTypes.string,
  padding: PropTypes.string,
  minHeigh: PropTypes.string,
  ShowSeperator: PropTypes.bool,
};

Modal.defaultProps = {
  padding: 0,
  ShowSeperator: true,
};
export default Modal;
